( function($, waTheme) {

    var LazyLoading = ( function($) {

        LazyLoading = function(options) {
            var that = this;

            // VARS
            that.list_name = options["names"]["list"];
            that.items_name = options["names"]["items"];
            that.pagind_name = options["names"]["paging"];
            that.load_class = "is-loading";

            // DOM
            that.$wrapper = ( options["$wrapper"] || false );
            that.$list = that.$wrapper.find(that.list_name);
            that.$window = $(window);

            // DYNAMIC VARS
            that.$paging = that.$wrapper.find(that.pagind_name);
            that.scrollWatcher = null;
            that.onScrollLoading = that.$paging.hasClass("is-lazy-loading-scroll");

            // INIT
            that.init();
        };

        LazyLoading.prototype.init = function() {
            var that = this;

            if (that.onScrollLoading) {
                that.addWatcher();
            }

            that.bindEvents();
        };

        LazyLoading.prototype.bindEvents = function() {
            var that = this;

            $(document).on("click", ".js-products-paging-load", function () {
                event.preventDefault();
                that.loadNextPage();
            });
        };

        LazyLoading.prototype.addWatcher = function() {
            var that = this;

            that.$window.on("scroll", scrollWatcher);
            function scrollWatcher() {
                var is_exist = $.contains(document, that.$wrapper[0]);
                if (is_exist) {
                    that.onScroll();
                } else {
                    that.$window.off("scroll", scrollWatcher);
                }
            }

            that.scrollWatcher = scrollWatcher;
        };

        LazyLoading.prototype.stopWatcher = function() {
            var that = this;

            if (that.scrollWatcher) {
                var scrollWatcher = that.scrollWatcher;
                that.$window.off("scroll", scrollWatcher);
            }
        };

        LazyLoading.prototype.onScroll = function() {
            var that = this,
                is_paging_exist = ( $.contains(document, that.$paging[0]) );

            if (is_paging_exist) {

                var $window = that.$window,
                    scroll_top = $window.scrollTop(),
                    display_height = $window.height(),
                    paging_top = that.$paging.offset().top;

                // If we see paging, stop watcher and run load
                if (scroll_top + display_height >= paging_top) {
                    that.stopWatcher();
                    that.loadNextPage();
                }

            } else {
                that.stopWatcher();
            }

        };

        LazyLoading.prototype.loadNextPage = function() {
            var that = this,
                next_page_url = getNextUrl(),
                $paging = that.$paging;

            function getNextUrl() {
                var $nextPage = that.$paging.find(".selected").next(),
                    result = false;

                if ($nextPage.length) {
                    result = $nextPage.find("a").attr("href");
                }

                return result;
            }

            function showLoad() {
                $paging.addClass(that.load_class);
                if (that.onScrollLoading) {
                    var $loading = `<div class="b-products-spinner position-absolute start-50 translate-middle">
                                    <div class="spinner-border text-gray-500" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>`;

                    $paging.append($loading);
                } else {
                    let $loader  = $(".js-products-paging-load");
                    let loadingText = $loader.data("loading-text");

                    $loader.find(".spinner-border").removeClass("d-none");
                    $loader.find(".spinner-text").html(loadingText);
                }
            }

            if (next_page_url) {

                showLoad();

                $.get(next_page_url, function(response) {
                    var $category = $(response),
                        $newItems = $category.find(that.list_name + " " + that.items_name),
                        $newPaging = $category.find(that.pagind_name);

                    that.$list.append($newItems);

                    $paging.after($newPaging);

                    $paging.remove();

                    that.$paging = $newPaging;

                    // Инициализируем заново товары
                    // new window.waTheme.init.shop.ProductsInit();

                    // Обновляем инстанс ленивой загрузки картинок
                    waTheme.init.site.ImageLazyLoad.update();

                    if (that.onScrollLoading) {
                        that.addWatcher();
                    }
                });
            }
        };

        return LazyLoading;

    })($);

    var ProductsInit = (function ($) {

        ProductsInit = function () {
            var that = this;

            // DOM
            that.$wrapper = $(".s-products-wrapper");

            // CONST

            // DYNAMIC VARS

            // INIT
            that.init();

            // EVENTS
        };

        ProductsInit.prototype.init = function () {
            var that = this;

            if (that.$wrapper.length) {
                that.$wrapper.each(function () {
                    new window.waTheme.init.shop.Products({
                        $wrapper: $(this),
                        use_lazy: !!$(this).find(".s-paging-wrapper").hasClass("is-lazy-loading"),
                    });

                    let $quantity = $(this).find(".s-quantity-section");
                    if ($quantity) {
                        $quantity.each(function () {
                            let product_id = $(this).parents(".s-product-wrapper").data("product-id");
                            new waTheme.init.shop.Quantity({
                                $wrapper: $(this),
                                denominator: window.waTheme["products"][`${product_id}`].denominator,
                                step: window.waTheme["products"][`${product_id}`].step,
                                min: window.waTheme["products"][`${product_id}`].min,
                                max: window.waTheme["products"][`${product_id}`].max,
                                locales: window.waTheme["products"][`${product_id}`].locales,
                                currency: window.waTheme["products"][`${product_id}`].currency,
                            });
                        });
                    }
                });
            }

        };

        return ProductsInit;

    })($);

    var Products = ( function($) {

        Products = function(options = {}) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$products = that.$wrapper.find(".s-product-wrapper:not(.s-product-wrapper-loaded)");

            // VARS
            that.use_lazy = ( options["use_lazy"] || false );
            that.use_slider = ( options['use_slider'] || false );

            console.log(that.use_lazy);

            // DYNAMIC VARS
            that.activeClass = "active";

            // INIT
            that.init();
        };

        Products.prototype.init = function() {
            var that = this;

            that.$products.addClass("s-product-wrapper-loaded");

            //
            //
            if (that.use_lazy) {
                that.initLazy();
            }
            //
            that.bindEvents();

        };

        Products.prototype.bindEvents = function() {
            var that = this,
                $wrapper = that.$wrapper;

            $wrapper.on("submit", "form.add-to-cart", function(event) {
                event.preventDefault();
                that.onSubmitProduct($(this));
            });

            $wrapper.on("click", ".js-preview-button", function (event) {
                event.preventDefault();
                that.onSubmitProduct($(this).parents(".s-product-wrapper").find("form.add-to-cart"), $(this).data("url"));
            });

            // Change image on hover
            $wrapper.on("mouseenter", ".b-products-images__nav", function () {

                //
                var $wrapper = $(this).parents(".b-products-images");

                //
                var step = parseInt($(this).data("step"));
                var currentStep = parseInt($wrapper.find(".b-products-images__nav.active").data("step"));

                if (step !== currentStep) {
                    that.changeImage($wrapper, step)
                }
            });

            $wrapper.on("mouseleave", ".b-products-images__nav", function () {
                if ($(this).data("return") === true) {
                    var $wrapper = $(this).parents(".b-products-images");
                    that.changeImage($wrapper, 1);
                }
            });

            // SKUS
            $wrapper.on("click", ".inline-select a", function (event) {
                event.preventDefault();
                that.onSelectClick( $(this) );
            });

            $wrapper.find(".s-skus-wrapper input[type=radio]").on("change", function () {
                var $input = $(this),
                    is_active = ($input.attr("checked") === "checked");

                if (is_active) {
                    that.onSkusClick( $(this) );
                }
            });

            $wrapper.on("change", ".js-sku-feature", function (event) {
                that.onSkusChange( $(this) );
            });

            //
            $wrapper.on("mouseenter", ".s-product-wrapper--skus", function (event) {
                var rect = $(this)[0].getBoundingClientRect();
                var rect_info = $(this).find(".s-info-wrapper")[0].getBoundingClientRect();
                $(this).find(".s-info-wrapper").css("height", rect_info.height);
                $(this).css("height", rect.height);
                $(this).addClass("is-hovered");
            });

            $wrapper.on("mouseleave", ".s-product-wrapper--skus", function (event) {
                $(this).removeClass("is-hovered");
                $(this).css("height", "");
                $(this).find(".s-info-wrapper").css("height", "");
            });
        };

        //

        Products.prototype.initLazy = function() {
            var that = this;

            new LazyLoading({
                $wrapper: that.$wrapper,
                names: {
                    list: ".s-products-list",
                    items: ".s-product-wrapper",
                    paging: ".s-paging-wrapper"
                }
            });

            console.log("initLazy");
        };

        // ADD PRODUCT

        Products.prototype.onSubmitProduct = function($form, href) {
            var that = this,
                $product = $form.closest(".s-product-wrapper"),
                $button = $form.find(".js-add-button"),
                $preview_button = $product.find(".js-preview-button"),
                product_name = $product.find(".s-product-header").text(),
                product_image = $product.find(".b-products-images__items .b-products-images__image:first-child").html(),
                product_href = href ? href : $form.data("url"),
                add_class = "btn-theme",
                added_class = "btn-outline-theme",
                timer = 0,
                time = 300;

            let toastHTML =
                `<div class="b-products-toast d-flex align-items-center">
                    <div class="b-products-toast__image">
                       ${product_image}
                    </div>
                    <div class="ms-3">
                        <div class="fs-md fw-bold mb-1">
                            ${window.waTheme.locale.product_added_to_cart}
                        </div>
                        <div class="fs-sm">
                            ${product_name}
                        </div>
                    </div>
                </div>`;

            $button.attr("disabled", true);
            $preview_button.attr("disabled", true);
            // $button.find(".spinner-border").addClass("d-none");

            if (product_href) {

                $.post(product_href, function( html ) {

                    $button.attr("disabled", false);
                    $preview_button.attr("disabled", false);
                    // $button.find(".spinner-border").removeClass("d-none");

                    var dialog = new window.waTheme.init.site.Dialog({
                        html: html
                    });

                    var $dialog = dialog.$dialog;

                    $dialog.on("addedToCart", function() {

                        $button
                            .attr("disabled", true)
                            .removeClass(add_class)
                            .addClass(added_class);
                        $button.find(".spinner-text").html(window.waTheme.locale["added_to_cart"]);

                        clearTimeout(timer);
                        timer = setTimeout( function() {
                            var is_exist = $.contains(document, $button[0]);
                            if (is_exist) {

                                $dialog.modal("hide");
                                $button.attr("disabled", false);

                                const toast = new window.waTheme.init.site.Toast({
                                    html: toastHTML
                                });
                            }
                        }, time);
                    });
                });

            } else {

                $.post($form.attr('action') + '?items=1&html=1', $form.serialize(), function(response) {
                    if (response.status === "ok") {

                        if (!waTheme.apps["shop"].cart) {
                            location.reload();
                            return false;
                        }

                        //
                        $button
                            .removeClass(add_class)
                            .addClass(added_class);
                        $button.find(".spinner-text").html(window.waTheme.locale["added_to_cart"]);

                        // Update Cart at Header
                        if (response["data"]) {
                            var count = response["data"]["count"],
                                text = response["data"]["total"];

                            if (text && count >= 0) {
                                waTheme.apps["shop"].cart.update(response["data"]);
                            }
                        }

                        clearTimeout(timer);
                        timer = setTimeout( function() {
                            var is_exist = $.contains(document, $button[0]);
                            if (is_exist) {
                                $button.attr("disabled", false);
                                $preview_button.attr("disabled", false);
                                const toast = new window.waTheme.init.site.Toast({
                                    html: toastHTML
                                });
                            }
                        }, time);

                    } else if (response.status === "fail") {

                        let toastHTML =
                            `<div class="b-products-toast d-flex align-items-center">
                                ${response.errors}
                            </div>`;

                        const toast = new window.waTheme.init.site.Toast({
                            html: toastHTML
                        });

                    }

                }, "json").always( function() {
                    // $button.find(".spinner-border").addClass("d-none");
                    $preview_button.attr("disabled", false);
                });
            }
        };

        Products.prototype.changeImage = function ($wrapper, step) {
            var that = this;

            var $images = $wrapper.find(".b-products-images__image");
            var $navs = $wrapper.find(".b-products-images__nav");
            var $dots = $wrapper.find(".b-products-images__dot");

            //
            $images.removeClass(that.activeClass);
            $navs.removeClass(that.activeClass);
            $dots.removeClass(that.activeClass);

            //
            $wrapper.find(`.b-products-images__image[data-step="${step}"]`).addClass(that.activeClass);
            $wrapper.find(`.b-products-images__nav[data-step="${step}"]`).addClass(that.activeClass);
            $wrapper.find(`.b-products-images__dot[data-step="${step}"]`).addClass(that.activeClass);

        };

        Products.prototype.onSkusClick = function( $link ) {
            var that = this,
                sku_id = $link.val(),
                price = $link.data("price"),
                compare_price = $link.data("compare-price"),
                image_id = $link.data('image-id');

            var $product = $link.closest(".s-product-wrapper");
            var product_data = waTheme.products_features[$product.attr("data-product-id")];

            var sku = (product_data.skus[sku_id] ? product_data.skus[sku_id] : null);
            if (!sku) { alert("SKU ERROR"); return false; }

            waTheme.addCurrency(product_data.currency_data);

            renderSKU($product, sku.sku);

            that.toggleAvailable($product, !$link.data('disabled'), sku, sku_id);

            that.updatePrice($product, product_data, sku, sku.id);
        };

        Products.prototype.onSelectClick = function( $link ) {
            var $select = $link.closest('.inline-select'),
                data = $link.data("value"),
                active_class = "active";

            //
            $select.find("a." + active_class).removeClass(active_class);
            //
            $link.addClass(active_class);
            //
            $select.find(".js-sku-feature")
                .val(data)
                .change();

            // that.updatePrice($link.closest("form"));
        };

        Products.prototype.updatePrice = function($product, product_data, sku, sku_id) {
            var that = this,
                hidden_class = "is-hidden";

            var $price = $product.find(".js-product-price");
            var $compare = $product.find(".js-compare-price");
            var $base_price = $product.find(".js-product-base-price");
            var $stock_base_ratio = $product.find(".js-stock-base-ratio");

            var $zero_price = $product.find(".js-product-price-zero");

            var $stock_total_ratio = $product.find(".js-stock-total-ratio");
            var $stock_total_quantity = $product.find(".js-stock-total-quantity");

            // console.log($product);

            // Настройки дробных
            var fractional_config = product_data["fractional_config"];
            // Массив с единицами измерения
            var units = product_data["units"];

            var price = sku["price"],
                compare_price = sku["compare_price"],
                stock_base_ratio = sku.stock_base_ratio,
                stock_unit_name,
                base_unit_name;

            console.warn(price);

            price = (parseFloat(price) >= 0 ? parseFloat(price) : 0);
            compare_price = (parseFloat(compare_price) > 0 ? parseFloat(compare_price) : null);
            stock_base_ratio = (parseFloat(stock_base_ratio) > 0 ? parseFloat(stock_base_ratio) : null);

            if (fractional_config["stock_units_enabled"]) {
                if (product_data.stock_unit_id && product_data.units[product_data.stock_unit_id]) {
                    stock_unit_name = units[product_data.stock_unit_id].name_short;
                }
            }

            if (fractional_config["base_units_enabled"]) {
                if (product_data.base_unit_id && (product_data.stock_unit_id !== product_data.base_unit_id) && units[product_data.base_unit_id] && stock_base_ratio) {
                    base_unit_name = units[product_data.base_unit_id].name_short;
                }
            }

            //
            var services_price = 0,
                price_sum = (price + services_price),
                compare_sum = (compare_price + services_price);

            // Render Price
            var price_string = waTheme.formatPrice(price_sum, { currency: product_data.currency, unit: stock_unit_name });
            $price.html(price_string);

            // Render Compare
            if (compare_price) {
                var compare_price_string = waTheme.formatPrice(compare_sum, { currency: product_data.currency, unit: stock_unit_name });
                $compare
                    .html(compare_price_string)
                    .removeClass(hidden_class);

            } else {
                $compare.addClass(hidden_class);
            }

            // Base Price
            if ($base_price.length) {
                if (base_unit_name) {
                    var base_sub = (price_sum/stock_base_ratio),
                        base_price_string = waTheme.formatPrice(base_sub, { currency: product_data.currency, unit: base_unit_name });

                    $base_price
                        .html(base_price_string)
                        .show();
                } else {
                    $base_price.hide();
                }
            }

            // Stock Base Ratio
            if ($stock_base_ratio.length) {
                if (stock_base_ratio) {
                    $stock_base_ratio
                        .html(waTheme.localizeNumber(formatNumber(sku.stock_base_ratio), { currency: product_data.currency }))
                        .show();
                } else {
                    $stock_base_ratio
                        .hide()
                        .html("");
                }
            }

            // Badges
            if (compare_price > 0) {
                // $product.find(".b-products-badges").removeClass("is-hidden");
                $product.find(".badge--compare").removeClass("is-hidden");
                // $product.find(".b-products-savings__profit").removeClass("is-hidden");

                let savings_percent = Math.round((compare_price - price) / (compare_price / 100));
                $product.find(".badge--compare").html(`- ${savings_percent} %`);

                let savings_price = waTheme.formatPrice(compare_price - price, { currency: that.currency, unit: stock_unit_name });
                // $product.find(".b-products-savings__price").html(savings_price);

            } else {
                // $product.find(".b-products-badges").addClass("is-hidden");
                $product.find(".badge--compare").addClass("is-hidden");
                // $product.find(".b-products-savings__profit").addClass("is-hidden");
            }

            // Zero Price
            if (price === 0) {
                $price.addClass(hidden_class);
                $compare.addClass(hidden_class);
                $base_price.hide();
                $zero_price.removeClass(hidden_class);
            } else {
                $price.removeClass(hidden_class);
                $zero_price.addClass(hidden_class);
            }

            //
            function getServicePrice() {
                // DOM
                var $checkedServices = that.$services.find("input:checked");

                // DYNAMIC VARS
                var services_price = 0;

                $checkedServices.each( function () {
                    var $service = $(this),
                        service_value = $service.val(),
                        service_price = 0;

                    var $serviceVariants = $form.find(".service-" + service_value + " .service-variants");

                    if ($serviceVariants.length) {
                        service_price = parseFloat( $serviceVariants.find(":selected").data("price") );
                    } else {
                        service_price = parseFloat( $service.data("price") );
                    }

                    services_price += service_price;
                });

                return services_price;
            }

            function formatNumber(number) {
                var result = number;
                if (typeof number !== "string") { return result; }

                var float_num = parseFloat(number);
                if (float_num < 1) {
                    var split_num = number.split(".");
                    if (split_num.length === 2) {
                        var decimal_part = split_num[1].replace(/^0+/, '');
                        number = roundNumber(float_num, split_num[1].length - decimal_part.length + 3).toFixed(8);
                    }
                } else {
                    number = roundNumber(float_num, 3).toFixed(8);
                }

                var parts = number.split(".");
                if (parts.length === 2) {
                    var tail = parts[1],
                        result2 = [],
                        result3 = [parts[0]];

                    if (tail.length) {
                        for (var i = 0; i < tail.length; i++) {
                            var letter = tail[tail.length - (i+1)];
                            if (letter !== "0" || result2.length) {
                                result2.push(letter);
                            }
                        }
                        if (result2.length) {
                            result3.push(result2.reverse().join(""));
                        }
                    }

                    result = result3.join(".");
                }

                return result;
            }

            function roundNumber(num, scale) {
                if(!String(num).includes("e")) {
                    return +(Math.round(num + "e+" + scale)  + "e-" + scale);
                } else {
                    var parts = String(num).split("e"),
                        sig = "";

                    if(+parts[1] + scale > 0) {
                        sig = "+";
                    }
                    return +(Math.round(+parts[0] + "e" + sig + (+parts[1] + scale)) + "e-" + scale);
                }
            }
        };

        Products.prototype.toggleAvailable = function($product, available, sku, sku_id) {
            var that = this,
                $button = $product.find("button[type=submit]"),
                cart_items = window.waTheme.cart_items,
                added_class = "is-added",
                is_added = false;

            if (sku_id) {
                for (const cartItemsKey in cart_items) {
                    if (cart_items[cartItemsKey]["sku_id"] === sku_id && is_added === false) {
                        is_added = true;
                        $button.addClass(added_class);
                        $button.removeClass("btn-theme").addClass("btn-outline-theme");
                        $button.find(".spinner-text").html(window.waTheme.locale["added_to_cart"]);
                    }
                }
            }

            if (is_added === false) {
                $button.removeClass(added_class);
                $button.removeClass("btn-outline-theme").addClass("btn-theme");
                $button.find(".spinner-text").html(window.waTheme.locale["add_to_cart"]);
            }

            // toggle button
            $button.attr("disabled", !available);

            // toggle stocks
            $product.find(".s-stocks-wrapper > div").each( function() {
                var $stock = $(this),
                    is_target = $stock.hasClass("sku-" + sku_id + "-stock");

                if (available && is_target) {
                    $stock.show();
                } else {
                    $stock.hide();
                }
            });

            $product.find(".s-stocks-wrapper > .sku-not-available").css("display", (available ? "none" : ""));

            // quantity
            // if (available) {
            //     that.$quantity_section.removeClass("d-none");
            // } else {
            //     that.$quantity_section.addClass("d-none");
            // }
        };

        Products.prototype.onSkusChange = function($wrapper) {
            var that = this;

            // DOM
            var $product = $wrapper.closest(".s-product-wrapper");
            var product_data = waTheme.products_features[$product.attr("data-product-id")];

            waTheme.addCurrency(product_data.currency_data);

            var key = getKey(),
                sku_features = product_data.features[key];

            var sku_id = null;

            if (sku_features) {
                var sku_name = false;
                try { sku_name = product_data.skus[sku_features.id].sku; } catch(e) {}

                sku_id = sku_id = sku_features.id;
                var sku = product_data.skus[sku_id];

                renderSKU($product, sku_name);
                //
                // that.updateSkuServices(sku.id);
                //
                // that.changeImage(sku.image_id);
                //
                if (sku_features.available) {
                    that.toggleAvailable($product,true, sku, sku.id);
                } else {
                    that.toggleAvailable($product,false, sku, sku.id);
                }

                //
                sku["compare_price"] = ( sku["compare_price"] ) ? sku["compare_price"] : 0 ;
                //
                that.updatePrice($product, product_data, sku, sku.id);

            } else {
                //
                that.toggleAvailable($product,false, sku_features);
            }

            function getKey() {
                var result = "";

                $product.find(".js-sku-feature").each( function () {
                    var $input = $(this);

                    result += $input.data("feature-id") + ':' + $input.val() + ';';
                });

                return result;
            }
        };

        return Products;

        function renderSKU($product, sku) {
            var $sku = $product.find(".js-product-sku"),
                $wrapper = $sku.closest(".s-sku-wrapper");

            if (sku) {
                $sku.text(sku);
                $wrapper.show();
            } else {
                $sku.text("");
                $wrapper.hide();
            }
        }

    })($);

    waTheme.init.shop.ProductsInit = ProductsInit;
    waTheme.init.shop.Products = Products;

    //
    new window.waTheme.init.shop.ProductsInit();

})(jQuery, window.waTheme);